// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f40577c7","455":"076d0b4c"}[chunkId] + ".chunk.js";
};